<template>
  <div class="layou">
    <div class="layout-menu-left">
      <!-- <div class="layout-profile">
        <img src="../../assets/img/logo.png">
      </div> -->
      <!-- 后台管理菜单 -->
      <el-menu :router=true :unique-opened=true class="el-menu-root" :default-active="defaultActive" :style="{height:number + 'px'}">
        <el-menu-item index="/Home"><img src="../../assets/img/homeicon.png" style="width: 15px;height: 15px;display: inline-block;margin-right: 10px" alt="">首页</el-menu-item>
        <el-submenu index="1" v-permission="'42'">
          <template slot="title">
            <img src="../../assets/img/survey.png" alt="">
            <span>美容皮肤科</span>
          </template>
          <el-menu-item index="/instrument/instrument" v-permission="'48'">皮肤科消费表</el-menu-item>
          <el-menu-item index="/doctorTable/index" v-permission="'101'">医生业绩表</el-menu-item>
          <el-menu-item index="/list/list" v-permission="'49'">消费表历史数据</el-menu-item>
          <el-menu-item index="/log/log" v-permission="'50'">消费表日志</el-menu-item>
          <el-menu-item index="/outpatients/outpatients" v-permission="'84'">门诊日志</el-menu-item>
          <el-menu-item index="/buckle/buckle" v-permission="'88'">划扣信息列表</el-menu-item>
          <el-menu-item index="/medical/medical" v-permission="'89'">激光类型电子病历</el-menu-item>
          <el-menu-item index="/skinMedical/medical" v-permission="'97'">中胚层类型电子病历</el-menu-item>
          <el-menu-item index="/injectMedical/medical" v-permission="'97'">注射类型电子病历</el-menu-item>
          <!-- <el-menu-item index="/record/record" v-permission="'85'">仪器使用记录</el-menu-item> -->
        </el-submenu>
        <el-submenu index="2" v-permission="'43'">
          <template slot="title">
            <img src="../../assets/img/draft.png" alt="">
            <span>美容外科</span>
          </template>
          <el-menu-item index="/registrationForm/registration" v-permission="'55'">美容外科手术表</el-menu-item>
          <el-menu-item index="/registrationForm/injection" v-permission="'56'">美容外科耗材表</el-menu-item>
          <el-menu-item index="/registrationForm/logData" v-permission="'57'">美容外科登记表日志</el-menu-item>
          <el-menu-item index="/observation/observation" v-permission="'100'">留观管理</el-menu-item>
        </el-submenu>
        <el-submenu index="3" v-permission="'44'">
          <template slot="title">
            <img src="../../assets/img/part.png" alt="">
            <span>注射微整科</span>
          </template>
          <el-menu-item index="/microsurgery/dermatology" v-permission="'58'">注射微整科登记表</el-menu-item>
          <el-menu-item index="/microsurgery/consumables" v-permission="'59'">注射微整科耗材表</el-menu-item>
          <el-menu-item index="/microsurgery/logData" v-permission="'60'">注射微整科登记表日志</el-menu-item>
        </el-submenu>
        <el-submenu index="4" v-permission="'45'">
          <template slot="title"><img src="../../assets/img/reserve.png" alt=""><span>管理配置</span> </template>
          <el-menu-item index="/identity/identity" v-permission="'70'">身份配置</el-menu-item>
          <el-menu-item index="/class/class" v-permission="'72'">职级配置</el-menu-item>
          <el-menu-item index="/configuration/configuration" v-permission="'83'">仪器配置</el-menu-item>
          <el-menu-item index="/consumable/consumable" v-permission="'83'">耗材配置</el-menu-item>
          <el-menu-item index="/diagnosisList/diagnosis" v-permission="'96'">病历模板</el-menu-item>
          <el-submenu index="4-1" v-permission="'61'">
            <template slot="title"><span>美容外科配置</span></template>
            <el-menu-item index="/setInject/setSurgical" v-permission="'62'">设置-美容外科手术表</el-menu-item>
            <el-menu-item index="/setInject/setProduction" v-permission="'63'">设置-产品</el-menu-item>
            <!-- <el-menu-item index="/setInject/setDiagnosis" v-permission="'64'">设置-诊断手术名称</el-menu-item> -->
            <el-menu-item index="/setInject/newDiagnosis" v-permission="'64'">诊断手术名称</el-menu-item>
            <el-menu-item index="/setInject/employee" v-permission="'64'">员工管理</el-menu-item>
          </el-submenu>
          <el-submenu index="4-2" v-permission="'65'">
            <template slot="title"><span>注射微整科配置</span></template>
            <el-menu-item index="/skinSet/setSkin" v-permission="'66'">设置-注射微整科手术表</el-menu-item>
            <el-menu-item index="/skinSet/setProduction" v-permission="'67'">设置-产品</el-menu-item>
            <!-- <el-menu-item index="/skinSet/setDiagnosis" v-permission="'68'">设置-诊断手术名称</el-menu-item> -->
            <el-menu-item index="/skinSet/newDiagnosis" v-permission="'68'">诊断手术名称</el-menu-item>
            <el-menu-item index="/skinSet/employee" v-permission="'64'">员工管理</el-menu-item>
          </el-submenu>
          <el-submenu index="4-3" v-permission="'69'">
            <template slot="title"><span>美容皮肤科配置</span></template>
            <el-menu-item index="/project/project" v-permission="'70'">项目管理</el-menu-item>
            <el-menu-item index="/material/material" v-permission="'73'">耗材管理</el-menu-item>
            <el-menu-item index="/yard/yard" v-permission="'74'">院区管理</el-menu-item>
            <el-menu-item index="/inform/inform" v-permission="'75'">信息来源</el-menu-item>
            <el-menu-item index="/card/card" v-permission="'71'">员工管理</el-menu-item>
            <el-menu-item index="/skin/skin" v-permission="'71'">仪器管理</el-menu-item>
          </el-submenu>
        </el-submenu>
        <el-submenu index="5" v-permission="'46'">
          <template slot="title">
            <img src="../../assets/img/reserve.png" alt="">
            <span>医务科</span>
          </template>
          <el-menu-item index="/case/case" v-permission="'76'">电子病历</el-menu-item>
          <el-menu-item index="/department/department" v-permission="'77'">科室管理</el-menu-item>
        </el-submenu>
        <el-submenu index="7" v-permission="'94'">
          <template slot="title">
            <img src="../../assets/img/reserve.png" alt="">
            <span>客户管理</span>
          </template>
          <el-menu-item index="/custom/customer/customer" v-permission="'95'">客户列表</el-menu-item>
          <el-menu-item index="/custom/order/list" v-permission="'98'">购买</el-menu-item>
          <el-menu-item index="/custom/order/consumeList" v-permission="'99'">划扣</el-menu-item>
        </el-submenu>
        <el-submenu index="6" v-permission="'47'">
          <template slot="title">
            <img src="../../assets/img/user.png" alt="">
            <span>角色权限</span>
          </template>
          <el-menu-item index="/role/webUser" v-permission="'78'">后台用户</el-menu-item>
          <el-menu-item index="/role/roleManagement" v-permission="'79'">后台角色</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

  </div>
</template>

<script>
import permission from '../../directives/permission/index'
export default {
  directives: {
    permission
  },
  name: "Main1",
  data() {
    return {
      notifyCount: 0,
      sysType: Lockr.get('sysType'),
      number: '',
      jurisdictionId: Lockr.get("skinJurisdictionId"),
      jurisdictionName: Lockr.get("skinJurisdictionName"),
    }
  },
  computed: {
    defaultActive() {
      return this.$route.path
    },
  },
  mounted() {
    // el-menu的高度
    this.number = document.documentElement.clientHeight
  },
}
</script>
<style scoped>
.layout-menu-left {
  width: 200px;
  min-height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: linear-gradient(180deg, #7ac7f4 0%, #5c43db 100%);
  /* padding-top: 15px; */
  box-sizing: border-box;
}

.layout-profile {
  background-color: #fff;
  text-align: center;
  /*padding: 25px 0px;*/
}

.layout-profile > img {
  width: 92px;
  padding: 10px 30px;
  /* height: 124px; */
  display: block;
  margin: 0 auto;
  background: #ffffff;
}

.layout-profile .el-dropdown {
  color: #ccc;
}

.el-menu-root img {
  width: 19px;
  margin: 0 8px 0 10px;
}
.el-menu-root {
  overflow-y: scroll;
  overflow-x: hidden;
}
.el-dropdown-link {
  font-size: 18px;
}

.el-icon-arrow-down {
  font-size: 14px;
}
</style>
